"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BusOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<rect x="1" y="12" width="2" height="4" rx="1"/><rect x="29" y="12" width="2" height="4" rx="1"/><circle cx="22" cy="20" r="1"/><circle cx="10" cy="20" r="1"/><path d="M24.08,2H7.92A3.93,3.93,0,0,0,4,5.92V24.15A1.85,1.85,0,0,0,5.85,26H7v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V26h6v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V26h1.15A1.85,1.85,0,0,0,28,24.15V5.92A3.93,3.93,0,0,0,24.08,2ZM11,28H9V26h2Zm12,0H21V26h2Zm3-4H6V16H26Zm0-10H6V8H26Zm0-8H6V5.92A1.92,1.92,0,0,1,7.92,4H24.08A1.92,1.92,0,0,1,26,5.92Z"/>';
var BusOutlineSVG = function BusOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BusOutlineSVG = BusOutlineSVG;
BusOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BusOutlineSVG);
exports.default = _default;